/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";
import birdWingsBackgroundUrl from "@/src/assets/img/authenticatedLayout/birdWingsBackground.png"

export const layoutAuthenticatedStyle = {
  sidebar: (theme: Theme) => ({ display: { xs: "none", lg: "block" }, zIndex: theme.zIndex.appBar - 1 }),
  pageContainer: (theme: Theme) => ({
    flexGrow: 1,
    minWidth: 0,
    position: "relative",
    backgroundColor: theme.palette.background.light,
    "&:before": {
      content: "''",
      position: "fixed",
      background: `url(${birdWingsBackgroundUrl})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom right",
      bottom: 0,
      right: 0,
      width: "50%",
      height: "50%",
      zIndex: 0,
      [theme.breakpoints.up("md")]: {
        width: "20%",
        height: "50%",
      },
    },
  }),
  childrenContainer: (theme: Theme) => ({
    padding: "4rem 0 1rem",
    minHeight: "100dvh",
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.up("md")]: {
      padding: "6rem 0 4rem",
    },
  }),
  navigation: {
    padding: "6rem 1rem 1.5rem 1rem",
  },
  navigationMobile: {
    padding: "1.5rem 1rem 0.5rem 1rem",
  },
};
